import { useState } from 'react';
import { Alert, Button } from '@mui/material';
import ReactJson from 'react18-json-view';
import axios from '../../../_utils/axios';
import Modal from '../../_common/Modal/Modal';
import PolarisIcon from '../../_common/PolarisIcon';
import OverflowMenuItem from '../../_common/OverflowMenu/OverflowMenuItem';
import styled from '@emotion/styled';
import { insertWordBreaks } from '@/_utils/utils';

type FileMediaInfoProps = {
  file: any;
};

const FileMediaInfo = ({ file }: FileMediaInfoProps) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mediaInfo, setMediaInfo] = useState(null);
  const [isRequested, setIsRequested] = useState(false);

  const getMediaInfo = () => {
    setIsRequested(false);
    setLoading(true);
    setOpen(true);
    axios
      .get(`/vfs/media_info/${file.origin_slug}/${file.key}/`)
      .then((res) => {
        const response = res.data?.response;
        if (!response) return null;
        else if (response?.message?.toLowerCase() === 'has been requested') {
          setIsRequested(true);
          setLoading(false);
        } else setMediaInfo(response?.body);
      })
      .catch((err) => console.log(err.response))
      .then(() => setLoading(false));
  };

  const renderModalContent = () => {
    if (loading) {
      return (
        <CenteredDiv>
          <Alert severity="info">Loading media info...</Alert>
        </CenteredDiv>
      );
    } else if (isRequested) {
      return (
        <CenteredDiv>
          <span style={{ marginBottom: 20 }}>
            <Alert severity="success">Media info has been requested.</Alert>
          </span>
          <Button color="primary" variant="outlined" onClick={getMediaInfo}>
            Refresh
          </Button>
        </CenteredDiv>
      );
    } else if (mediaInfo) {
      return <ReactJson collapseStringsAfterLength={50} enableClipboard={false} src={mediaInfo} style={{ padding: 12 }} theme="winter-is-coming" />;
    } else {
      return (
        <CenteredDiv>
          <Alert severity="error">There was an error retrieving media info.</Alert>
        </CenteredDiv>
      );
    }
  };

  const handleOnClick = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
    getMediaInfo();
  };

  return (
    <OverflowMenuItem key={file.key} onClick={handleOnClick as any}>
      <PolarisIcon icon="info" height={24} /> View Media Info
      {open && (
        <Modal
          loading={loading}
          open={open}
          onClose={() => setOpen(false)}
          title={`Media Info: ${insertWordBreaks(file.name)}`}
          icon={<PolarisIcon icon="info" />}
          paper={{
            style: {
              minHeight: 290
            }
          }}
        >
          {renderModalContent()}
        </Modal>
      )}
    </OverflowMenuItem>
  );
};

export default FileMediaInfo;

const CenteredDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 180px;

  & > span {
    display: flex;
    align-items: center;
  }
`;
